import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById('navbar');
      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add('nav-scrolled');
        } else {
          navbar.classList.remove('nav-scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path, sectionId = null) => {
    setIsMobileMenuOpen(false);
    
    if (sectionId && location.pathname === '/') {
      // Same page pe hai toh scroll karo
      const element = document.querySelector(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 80;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    } else if (sectionId) {
      // Different page pe hai toh pehle home jao phir scroll
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(sectionId);
        if (element) {
          const offsetTop = element.offsetTop - 80;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }
      }, 100);
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navLinks = [
    { name: 'Home', path: '/', sectionId: '#home' },
    { name: 'Services', path: '/services', sectionId: '#services' },
    { name: 'About', path: '/about', sectionId: '#about' },
    { name: 'Portfolio', path: '/portfolio', sectionId: '#portfolio' },
    { name: 'Team', path: '/team', sectionId: null },
    { name: 'Contact', path: '/contact', sectionId: '#contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 nav-blur transition-all duration-300" id="navbar">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          
          {/* Logo */}
          <Link 
            to="/"
            className="flex items-center gap-3"
            onClick={() => handleNavClick('/', '#home')}
          >
            <img 
              src="/NestedInfo.png"
              alt="NestedInfo Logo"
              className="w-12 h-12 object-contain rounded-xl"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/48x48?text=N';
              }}
            />
            <span className="text-2xl font-bold text-gray-900">
              Nested<span className="text-blue-500">Info</span>
            </span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => handleNavClick(link.path, link.sectionId)}
                className={`text-gray-700 hover:text-green-500 transition-colors font-medium relative group ${
                  location.pathname === link.path ? 'text-green-500' : ''
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-green-500 transition-all duration-300 ${
                  location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                }`}></span>
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <button 
            onClick={() => handleNavClick('/contact', '#contact')}
            className="hidden md:flex items-center gap-2 magnetic-btn bg-green-500 text-white px-7 py-3.5 rounded-full font-semibold hover:bg-green-600 transition-all shadow-lg hover:shadow-green-500/30"
          >
            Let's Talk
            <i className="fas fa-arrow-right"></i>
          </button>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-2xl text-gray-800" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`md:hidden bg-white border-t border-gray-100 shadow-lg transition-all duration-300 ${
          isMobileMenuOpen ? 'block' : 'hidden'
        }`}
      >
        <div className="flex flex-col p-6 gap-4">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => handleNavClick(link.path, link.sectionId)}
              className={`text-left text-gray-700 hover:text-green-500 py-2 font-medium ${
                location.pathname === link.path ? 'text-green-500' : ''
              }`}
            >
              {link.name}
            </button>
          ))}
          <button 
            onClick={() => handleNavClick('/contact', '#contact')}
            className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold text-center mt-2"
          >
            Let's Talk
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;